export default "__VITE_ASSET__0h0VrD3C__"